export default {
    items: {
        header: {
            title: true,
            name: 'Personalwesen',
            class: ''
        },
        header_rb: {
            title: true,
            name: 'Rufbereitschaft',
            class: ''
        },
        booking: {
            name: 'Auskunft Mitarbeiter',
            url: '/base',
            icon: 'fa fa-hourglass-o fa-md',
            open: true,
            children: [
                {
                    name: 'Buchnungen',
                    url: '/bookings/calendar',
                },
                {
                    name: 'Anwesenheit',
                    url: '/bookings/anwesenheit',
                }

            ]
        },
        reports: {
            name: 'Auswertungen',
            url: '/base',
            icon: 'fa fa-bar-chart fa-md',
            open: true,
            children: [
                {
                    name: 'Urlaub-/Überstundensaldo',
                    url: '/reports/hol_ueb',
                },
                {
                    name: 'Mitarbeiterauskunft',
                    url: '/reports/user',
                },
                {
                    name: 'Lohnarten',
                    url: '/reports/lohn',
                },
            ]
        },
        rb: {
            name: 'Rufbereitschaft',
            url: '/base',
            icon: 'fa fa-phone fa-md',
            open: true,
            children: [
                {
                    name: 'Raster',
                    url: '/rb/raster',
                },
                {
                    name: 'Kalender',
                    url: '/rb/calendar',
                },
                {
                    name: 'Rufer',
                    url: '/rb/caller',
                },
            ]
        },
        rb_admin: {
            name: 'Rufbereitschaft',
            url: '/base',
            icon: 'fa fa-phone fa-md',
            open: true,
            children: [
                {
                    name: 'Raster',
                    url: '/rb/raster',
                },
                {
                    name: 'Kalender',
                    url: '/rb/calendar',
                },
                {
                    name: 'Rufer',
                    url: '/rb/caller',
                },
                {
                    name: 'Einstellungen',
                    url: '/rb/settings',
                },
            ]
        },
        basis_data: {
            name: 'Stammdaten',
            url: '/base',
            icon: 'fa fa-database fa-md',
            open: true,
            children: [
                {
                    name: 'Arbeitszeitraster',
                    url: '/basis/azra',
                },
                /*{
                    name: 'Pausen',
                    url: '/basis/breaks',
                },*/
                {
                    name: 'Kostenstellen',
                    url: '/basis/kost',
                },
                {
                    name: 'Mitarbeitergruppen',
                    url: '/basis/migr',
                },
                {
                    name: 'Mitarbeiter',
                    url: '/basis/mita',
                },
                {
                    name: 'Lohnarten',
                    url: '/basis/lohn',
                },
                {
                    name: 'Import',
                    url: '/basis/import',
                },
            ]
        },
        zk: {
            name: 'Mitarbeiter',
            url: '/base',
            icon: 'fa fa-hourglass-o fa-md',
            open: true,
            children: [
                {
                    name: 'Anwesenheit',
                    url: '/zeitkontrolle/anwesenheit',
                }, {
                    name: 'Zeiterfassung',
                    url: '/zeitkontrolle/zeiterfassung',
                }, {
                    name: 'Auskunft',
                    url: '/bookings/auskunft',
                },
                {
                    name: 'Buchnungen',
                    url: '/bookings/calendar',
                },
                {
                    name: 'Urlaubskalender',
                    url: '/bookings/holiday_calendar',
                },
                {
                    name: 'Einstellungen',
                    url: '/zeitkontrolle/settings',
                },
            ]
        },
}
}
